<template>
  <div class="rp-wrapper">
    <div class="modal-panel">
      <div class="modal-head">
        <h3 class="modal-title">Realizar pago</h3>
        <p class="modal-sub">
          Matrícula <strong>{{ matricula }}</strong>
        </p>
      </div>

      <div class="modal-body">
        <div class="alert-box alert-box-danger">
          <v-icon size="18" color="#FF6B6B">mdi-alert</v-icon>
          <div class="alert-text">
            Revisa atentamente la membresía seleccionada. Una vez guardada, no
            hay forma de modificarla.
          </div>
        </div>

        <div v-if="miembro && !miembro.inscripcion_pagada" class="field mt-lg">
          <label class="field-label">Inscripción</label>
          <v-switch
            v-model="cobrarInscripcion"
            label="Cobrar inscripción"
            hide-details
            class="dark-switch"
          ></v-switch>

          <v-text-field
            v-if="cobrarInscripcion"
            v-model.number="montoInscripcion"
            type="number"
            outlined
            dense
            hide-details="auto"
            placeholder="Monto de inscripción"
            prefix="$"
            class="dark-input mt-sm"
          ></v-text-field>

          <div
            v-if="cobrarInscripcion && montoInscripcion > 0"
            class="selected-summary"
          >
            <span class="summary-chip">Inscripción</span>
            <span class="summary-detail">${{ montoInscripcion }}</span>
          </div>
        </div>

        <div class="field mt-lg">
          <label class="field-label">Selecciona una membresía</label>
          <v-select
            v-model="membresiaSeleccionada"
            :items="membresias"
            item-text="nombre"
            item-value="id"
            return-object
            single-line
            outlined
            dense
            hide-details="auto"
            class="dark-input"
          ></v-select>
          <div
            v-if="membresiaSeleccionada && membresiaSeleccionada.nombre"
            class="selected-summary"
          >
            <span class="summary-chip">{{ membresiaSeleccionada.nombre }}</span>
            <span class="summary-detail"
              >${{ membresiaSeleccionada.precio }} ·
              {{ membresiaSeleccionada.duracion }} días</span
            >
          </div>
        </div>

        <div class="field mt-lg">
          <label class="field-label">Fecha del pago</label>
          <div class="date-picker-wrapper">
            <v-date-picker
              v-model="fechaSeleccionada"
              :first-day-of-week="1"
              locale="es-se"
              type="date"
              full-width
              no-title
              class="dark-date-picker"
            ></v-date-picker>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn-ghost" @click="cerrarDialogo">Cerrar</button>
        <button class="btn-primary" @click="confirmarPago">Registrar</button>
      </div>
    </div>

    <!-- Dialogo de confirmación de fecha -->
    <v-dialog v-model="mostrarConfirmacionFecha" max-width="440px" persistent>
      <div class="modal-panel">
        <div class="modal-head modal-head-warning">
          <v-icon size="20" color="#FFB84D" class="mr-2">mdi-alert</v-icon>
          <h3 class="modal-title">Confirmar fecha diferente</h3>
        </div>

        <div class="modal-body">
          <p class="modal-text">
            Estás seleccionando una fecha diferente al día actual:
          </p>
          <div class="confirm-details">
            <div class="confirm-row">
              <span class="confirm-label">Fecha seleccionada</span>
              <span class="confirm-value">{{
                fechaSeleccionadaFormateada
              }}</span>
            </div>
            <div class="confirm-row">
              <span class="confirm-label">Fecha actual</span>
              <span class="confirm-value">{{ fechaActualFormateada }}</span>
            </div>
          </div>
          <p class="modal-text-warning">
            ¿Estás seguro de que deseas continuar?
          </p>
        </div>

        <div class="modal-footer">
          <button class="btn-ghost" @click="mostrarConfirmacionFecha = false">
            Cancelar
          </button>
          <button class="btn-primary" @click="realizarPagoConfirmado">
            Confirmar
          </button>
        </div>
      </div>
    </v-dialog>

    <!-- Loading overlay -->
    <v-overlay :value="cargando" opacity="0.85" color="#0E0E10">
      <div class="loading-inner">
        <div class="spinner"></div>
        <p class="loading-text">Procesando pago…</p>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import HttpService from "../../Servicios/HttpService";
export default {
  name: "RealizarPago",
  props: ["matricula", "miembro"],

  data: () => ({
    membresiaSeleccionada: { id: "", nombre: "", precio: "", duracion: "" },
    fechaSeleccionada: new Date().toISOString().split("T")[0],
    membresias: [],
    cargando: false,
    mostrarConfirmacionFecha: false,
    cobrarInscripcion: false,
    montoInscripcion: null
  }),
  computed: {
    fechaSeleccionadaFormateada() {
      if (!this.fechaSeleccionada) return "";
      const [year, month, day] = this.fechaSeleccionada.split("-");
      const fechaLocal = new Date(year, month - 1, day);

      return fechaLocal.toLocaleDateString("es-MX", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        timeZone: "America/Mexico_City"
      });
    },

    fechaActualFormateada() {
      const ahora = new Date();
      return ahora.toLocaleDateString("es-MX", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        timeZone: "America/Mexico_City"
      });
    }
  },

  mounted() {
    this.obtenerMembresias();
  },

  methods: {
    obtenerMembresias() {
      const payload = { metodo: "get" };
      HttpService.obtenerConDatos(payload, "membresias.php").then(respuesta => {
        this.membresias = respuesta;
      });
    },

    cerrarDialogo() {
      this.$emit("cerrar", false);
    },

    esFechaDiferente() {
      if (!this.fechaSeleccionada) return false;

      const ahora = new Date();
      const hoy = new Date(
        ahora.getFullYear(),
        ahora.getMonth(),
        ahora.getDate()
      );

      const [year, month, day] = this.fechaSeleccionada.split("-");
      const fechaSelec = new Date(year, month - 1, day);

      return fechaSelec.getTime() !== hoy.getTime();
    },

    confirmarPago() {
      if (!this.membresiaSeleccionada) return;

      if (this.esFechaDiferente()) {
        this.mostrarConfirmacionFecha = true;
      } else {
        this.realizarPagoConfirmado();
      }
    },

    realizarPagoConfirmado() {
      this.cargando = true;
      this.mostrarConfirmacionFecha = false;

      const formatDateTimeMexico = () => {
        const fechaPart = this.fechaSeleccionada;
        const ahora = new Date();
        const horas = String(ahora.getHours()).padStart(2, "0");
        const minutos = String(ahora.getMinutes()).padStart(2, "0");
        const segundos = String(ahora.getSeconds()).padStart(2, "0");

        return `${fechaPart} ${horas}:${minutos}:${segundos}`;
      };

      let payload = {
        metodo: "pagar",
        pago: {
          matricula: this.matricula,
          pago: this.membresiaSeleccionada.precio,
          idMembresia: this.membresiaSeleccionada.id,
          duracion: this.membresiaSeleccionada.duracion,
          fecha: formatDateTimeMexico(),
          idUsuario: localStorage.getItem("idUsuario"),
          inscripcion: this.cobrarInscripcion
            ? { monto: this.montoInscripcion }
            : undefined
        }
      };

      console.log("Fecha enviada:", payload.pago.fecha);

      HttpService.registrar(payload, "miembros.php")
        .then(registrado => {
          this.cargando = false;
          if (registrado) {
            this.$emit("pagado", registrado);
          }
        })
        .catch(error => {
          this.cargando = false;
          console.error("Error al realizar el pago:", error);
        });
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;700&family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@500&display=swap");

/* ===== TOKENS ===== */
.rp-wrapper {
  --bg: #0e0e10;
  --card: #17171a;
  --card-border: #26262a;
  --text-primary: #f2f2ed;
  --text-secondary: #8c8c93;
  --text-tertiary: #5c5c62;
  --accent: #c8ff4d;
  --accent-dim: rgba(200, 255, 77, 0.12);
  --warning: #ffb84d;
  --error: #ff6b6b;
  --radius: 4px;

  --font-display: "Space Grotesk", sans-serif;
  --font-body: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  --font-mono: "JetBrains Mono", monospace;

  font-family: var(--font-body);
  color: var(--text-primary);
}

.modal-panel {
  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  overflow: hidden;
}

.modal-head {
  padding: 22px 24px;
  border-bottom: 1px solid var(--card-border);
}

.modal-head-warning {
  display: flex;
  align-items: center;
}

.modal-title {
  font-family: var(--font-display);
  font-size: 17px;
  font-weight: 700;
  margin: 0 0 4px;
}

.modal-head-warning .modal-title {
  margin: 0;
}

.modal-sub {
  font-size: 12.5px;
  color: var(--text-secondary);
  margin: 0;
}

.modal-sub strong {
  color: var(--text-primary);
}

.modal-body {
  padding: 24px;
}

.modal-text {
  font-size: 13px;
  color: var(--text-secondary);
  margin: 0 0 14px;
}

.modal-text-warning {
  font-size: 13px;
  color: var(--error);
  font-weight: 600;
  margin: 14px 0 0;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid var(--card-border);
}

/* ===== ALERT ===== */
.alert-box {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  border-radius: var(--radius);
  padding: 12px 14px;
}

.alert-box-danger {
  background: rgba(255, 107, 107, 0.08);
  border: 1px solid rgba(255, 107, 107, 0.25);
}

.alert-text {
  font-size: 12.5px;
  color: var(--text-secondary);
  line-height: 1.5;
}

/* ===== FIELD ===== */
.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field-label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--text-secondary);
  text-transform: uppercase;
}

.selected-summary {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 4px;
  flex-wrap: wrap;
}

.summary-chip {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: var(--radius);
  background: var(--accent-dim);
  color: var(--accent);
  font-size: 11.5px;
  font-weight: 600;
}

.summary-detail {
  font-size: 12px;
  color: var(--text-tertiary);
  font-family: var(--font-mono);
}

.date-picker-wrapper {
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  overflow: hidden;
}

/* ===== CONFIRM DATES ===== */
.confirm-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 4px;
}

.confirm-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  padding: 10px 12px;
}

.confirm-label {
  font-size: 12px;
  color: var(--text-tertiary);
}

.confirm-value {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-primary);
  font-family: var(--font-mono);
}

/* ===== BUTTONS ===== */
.btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--accent);
  color: var(--bg);
  border: none;
  border-radius: var(--radius);
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.15s ease;
}

.btn-primary:hover {
  filter: brightness(1.08);
}

.btn-ghost {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease;
}

.btn-ghost:hover {
  border-color: var(--text-tertiary);
  color: var(--text-primary);
}

/* ===== LOADING ===== */
.loading-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.spinner {
  width: 26px;
  height: 26px;
  border: 2px solid var(--card-border);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

.loading-text {
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--text-secondary);
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* ===== Overrides v-select (Vuetify) ===== */
.dark-input >>> .v-input__slot {
  background: var(--bg) !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  min-height: 42px !important;
}

.dark-input >>> fieldset {
  border-color: var(--card-border) !important;
  border-width: 1px !important;
  border-radius: 4px !important;
}

.dark-input >>> .v-input--is-focused fieldset {
  border-color: var(--accent) !important;
  border-width: 1.5px !important;
}

.dark-input >>> input,
.dark-input >>> .v-select__selection {
  color: var(--text-primary) !important;
  font-family: var(--font-body) !important;
  font-size: 14px !important;
}

.dark-input >>> .v-icon {
  color: var(--text-tertiary) !important;
}

.dark-input >>> .v-messages {
  color: var(--text-tertiary) !important;
  font-size: 11.5px !important;
}

/* Menú desplegable del select */
.rp-wrapper >>> .v-menu__content {
  background: var(--card) !important;
  border: 1px solid var(--card-border) !important;
  border-radius: 4px !important;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5) !important;
}

.rp-wrapper >>> .v-list {
  background: transparent !important;
}

.rp-wrapper >>> .v-list-item__title {
  color: var(--text-primary) !important;
  font-family: var(--font-body) !important;
  font-size: 13.5px !important;
}

.rp-wrapper >>> .v-list-item:hover {
  background: rgba(255, 255, 255, 0.04) !important;
}

.rp-wrapper >>> .v-list-item--active {
  background: var(--accent-dim) !important;
}

.rp-wrapper >>> .v-list-item--active .v-list-item__title {
  color: var(--accent) !important;
}

/* ===== Overrides v-date-picker (Vuetify) ===== */
.dark-date-picker {
  background: var(--card) !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.date-picker-wrapper >>> .v-picker__body {
  background: var(--card) !important;
}

.date-picker-wrapper >>> .v-date-picker-table {
  background: var(--card) !important;
}

.date-picker-wrapper >>> .v-date-picker-table th {
  color: var(--text-tertiary) !important;
  font-size: 10.5px !important;
  font-family: var(--font-mono) !important;
}

.date-picker-wrapper >>> .v-date-picker-table .v-btn {
  color: var(--text-secondary) !important;
}

.date-picker-wrapper >>> .v-date-picker-table .v-btn.v-btn--active {
  background: var(--accent) !important;
  color: var(--bg) !important;
}

.date-picker-wrapper >>> .v-date-picker-header {
  background: var(--card) !important;
}

.date-picker-wrapper >>> .v-date-picker-header button,
.date-picker-wrapper >>> .v-date-picker-header .v-icon {
  color: var(--text-primary) !important;
}

.date-picker-wrapper >>> .v-date-picker-table--date .v-btn.v-btn--outlined {
  border-color: var(--card-border) !important;
}

/* ===== Overlay ===== */
.rp-wrapper >>> .v-overlay__content {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ===== Overrides v-switch (Vuetify) ===== */
.dark-switch >>> label {
  color: var(--text-primary) !important;
  font-family: var(--font-body) !important;
  font-size: 13.5px !important;
}

.dark-switch >>> .v-input--switch__track {
  background: var(--card-border) !important;
  opacity: 1 !important;
}

.dark-switch >>> .v-input--switch__thumb {
  background: var(--text-tertiary) !important;
}

.dark-switch >>> .v-input--is-dirty .v-input--switch__track {
  background: var(--accent) !important;
  opacity: 0.4 !important;
}

.dark-switch >>> .v-input--is-dirty .v-input--switch__thumb {
  background: var(--accent) !important;
}

.mt-sm {
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Miembros/RealizarPago.vue